import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import {Lazyload} from "vant";
import "vant/lib/index.css";
import router from "./router/routes";
import '@vant/touch-emulator';
import axios from "axios";

// import moment from "moment"; //导入文件

// Vue.prototype.$moment = moment; //赋值使用

// moment.locale("zh-cn"); //需要汉化
import debounce from '../src/mixins/debounce'
import 'vant/lib/address-list/style/less';
import { setStorage } from "./utils/common";


Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe']
Vue.mixin(debounce)

Vue.use(Vant);
Vue.use(Lazyload)
// Vue.use(moment)
Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    goBack() {
      this.$router.back();
    },
  },
});

// 动态修改浏览器导航栏图标和文字
export function changeIconTitle() {
	axios({
		method: 'get',
		url: `/cloud/api/sys/envValue`
	  })
	.then((response)=>{
		const {result} = response.data
		setStorage('env', result.env)
		const changeFavicon = link => {
			let $favicon = document.querySelector('link[rel="icon"]');
			if ($favicon !== null) {
				$favicon.href = link;
			} else {
				$favicon = document.createElement("link");
				$favicon.rel = "icon";
				$favicon.href = link;
				document.head.appendChild($favicon);
			}
		};
		let iconUrl = "/gdfavicon.ico"; // 图片地址
		changeFavicon(iconUrl); // 动态修改网站图标
		let title = '无为股道'; // 网站标题

		// 筛选拦截
		const filterUrl = ['/bind', '/shareApp', '/dlApp']
		if(!filterUrl.includes(window.location.pathname)) {
			document.title = title; // 动态修改网站标题
		}

	});
	
}

changeIconTitle()
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
